import {Button, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {Dialog2} from "../../../../../misc/Dialog2";
import {ElevationApp} from "../ElevationApp";
import {Workspace} from "../model/view/MdViewSettings";

// shown when the loaded opening is a secondary of a multi-opening screen and the workspace shows
// the frame: the frame belongs to the primary opening, so the user goes there, or stays on this
// opening's door or hardware.
export function SecondaryOpeningDialog(props: {
    app: ElevationApp;
    secondaryOf: {primary: number; primaryName: string; slot: string};
    onWorkspaceChange(workspace: Workspace): void;
}) {
    const navigate = useNavigate();
    const app = props.app;
    const project = app.project?.id;
    const alternative = app.alternative;
    const primary = props.secondaryOf.primary;

    const primaryUrl = alternative != null
        ? `/project/${project}/quote/${alternative}/elevation-tool?quoteOpening=${primary}&alternative=${alternative}&workspace=screen`
        : `/project/${project}/shop-drawing/elevation-tool?opening=${primary}&workspace=screen`;

    return (
        <Dialog2 open onClose={() => {}}>
            <DialogTitle>Frame of opening {props.secondaryOf.primaryName}</DialogTitle>
            <DialogContent>
                Opening {app.opening?.name} fills door slot {props.secondaryOf.slot} on the frame of
                opening {props.secondaryOf.primaryName}. Edit the frame on that opening.
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.onWorkspaceChange("door")}>Edit {app.opening?.name} door</Button>
                <Button onClick={() => props.onWorkspaceChange("hardware")}>Edit {app.opening?.name} hardware</Button>
                <Button variant="contained" onClick={() => navigate(primaryUrl)}>Go to {props.secondaryOf.primaryName} frame</Button>
            </DialogActions>
        </Dialog2>
    );
}
